import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { createSupervisionColumns } from '../../../../utils/createSupervisionColumns';

const ListSupervisions = ({ owner }) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const [refreshData, setRefreshData] = useState(false);

  const columns = createSupervisionColumns({
    t,
    dispatchAPI,
    message,
    setRefreshData,
    refreshData
  });

  return (
    <ListResource
      resourceName="supervisions"
      extraQuery={`main_informations.owner=${owner._id}`}
      populate="pensioners,petsitting_address"
      forceRefresh={refreshData}
      columns={columns}
      showEdit={false}
      withPageHeader={false}
      withCreateButton={false}
      customActionColumn
      path="/supervisions"
    />
  );
};

export default ListSupervisions;

ListSupervisions.propTypes = {
  owner: PropTypes.shape({
    _id: PropTypes.string.isRequired
  }).isRequired
};
